<template>
	<div class="goal-item-small d-flex border-bottom mb-3 pb-3">
		<div class="rounded-circle circle-cropped avatar-sm mr-2 text-center text-sm text-white bg-gray-800" v-tooltip.bottom="goal.scope == 'user' ? goal.user.display_name : 'Facility Goal'">
			<img v-if="goal.scope == 'user'" :src="goal.user.photo_url" class="img-fluid">
			<i v-else class="far fa-hospital"></i>
		</div>	
		<div class="d-flex flex-grow-1">
			<div class="flex-grow-1 mr-3">
				<span class="text-xl leading-tight">{{ goal.active_goal_segment.matching_checkins }}</span>
                <span class="text text-gray-500"> / {{ goal.goal_type == 'charge' ? numeral(goal.target).format('$0a') : goal.target }}</span>

                <div class="text-gray-500 text-sm">
                    {{ goal.frequency == 'day' ? 'Daily ' : goal.frequency == 'week' ? 'Weekly ' : 'Monthly ' }}
                    <span v-if="goal.goal_type == 'referral'" v-html="'Patient Referrals'" />
                    <span v-if="goal.goal_type == 'charge'" v-html="'Generated Charges'" />
                    <span v-if="goal.goal_type == 'checkin'" v-html="'Check-ins'" />
                    <span v-if="goal.goal_type == 'service_line'" v-html="'Check-ins promoting ' + goal.service_lines[0].label" />
                    <span v-if="goal.goal_type == 'specialty'" v-html="'Check-ins with ' + goal.specialties[0].label" />
                    <span v-if="goal.goal_type == 'checkin_type'" v-html="'Check-ins of type ' + goal.checkin_type ? goal.checkin_type.label : '(unknown)'" />
                </div>
			</div>
			<goal-item-donut :segment="goal.active_goal_segment" display="compact" />
		</div>
	</div>				
</template>

<script>

	import GoalItemDonut from './GoalItemDonut';
	export default {
		props: ['goal'],

		components: {
			GoalItemDonut
		}
	}
</script>